import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, Inject } from "@angular/core";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IHolding } from "src/app/interfaces/holding";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { environment } from "src/environments/environment.prod";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-holding-entry",
  templateUrl: "./holding-entry.component.html",
  styleUrls: ["./holding-entry.component.css"]
})
export class HoldingEntryComponent {
  imgURL: any;
  form: FormGroup;
  url = environment.BaaseUrl;
  fileName: string;
  fielExtension: string;
  base64textString: string;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    public dialogRef: MatDialogRef<HoldingEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IHolding
  ) {
    if (this.data) {
      this.imgURL = this.url + "/" + this.data.FileAddress;
      this.fileName = this.data.FileDisplayName;
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(3)
        ])
      ],
      fileData: [this.data && this.data.FileData ? this.data.FileData : null],
      FileExtension:['png'],
      FileDisplayName: [
        this.data && this.data.FileDisplayName
          ? this.data.FileDisplayName
          : null
      ],
      FileAddress: [
        this.data && this.data.FileAddress ? this.data.FileAddress : null
      ],
      HoldingGuid: [
        this.data && this.data.HoldingEncryptCode ? this.data.HoldingEncryptCode : null
      ]
    });
  }

  onFileChange(event) {
    var files = event.target.files;
    var file = files[0];
    if (files && file) {
      if (file.size <= 100000) {
        this.fileName = file.name;
        this.form.patchValue({
          FileDisplayName: file.name
        });
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("require.fileUpload", {
            size: "100kb"
          }),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    }
  }

  _handleReaderLoaded(readerEvt) {
    this.imgURL = "data:image/png;base64," + btoa(readerEvt.target.result);
    this.form.patchValue({
      fileData: btoa(readerEvt.target.result)
    });
  }

  submit(data: IHolding) {
    // this.dialogRef.close(data);
    this.errors = new Array();

    if (this.data && this.data.FileDisplayName) {
      data.FileExtension = 'png';
      this.holdingService.edit(data).subscribe(
        () => {
          this.dialogRef.close();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      if (data.FileData.length > 0) {
        this.holdingService.add(data).subscribe(
          () => {
            this.dialogRef.close();
          },
          err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          }
        );
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("require.image"),
          "ok",
          3000,
          SoundEnum.beep
        );
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
